// src/components/Onboarding/Tooltip.tsx
import React from 'react';
import { Placement } from './Onboarding';

interface Props {
  text: string;
  children: React.ReactNode;
  currentStep?: number;
  totalSteps?: number;
  placement?: Placement;
}

export default function Tooltip({
  text,
  children,
  currentStep,
  totalSteps,
  placement = 'mid',
}: Props) {
  const MAX_WIDTH = 550;

  // Base fixed style (centered horizontally)
  const style: React.CSSProperties = {
    position: 'fixed',
    left: '25%',
    transform: 'translateX(-20%)',
    maxWidth: `${MAX_WIDTH}px`,
    zIndex: 50,
  };

  // Vertical positioning
  switch (placement) {
    case 'top':
      style.top = '16%';
      break;
    case 'mid':
      style.top = '45%';
      style.transform = 'translateX(-20%)';
      break;
    case 'bottom':
      style.bottom = '15%';   // sits nicely above navbar
      break;
  }

  return (
    <>
      {/* overlay */}
      <div
        className="fixed inset-0 bg-black/40 z-40"
      />

      {/* tooltip card */}
      <div
        className="
          bg-brandPurpleLight 
          text-brandPurpleDark 
          p-4              /* more padding */
          rounded-lg       /* softer rounding */
          shadow-xl        /* deeper, softer shadow */
          space-y-3        /* vertical spacing in stack */
        "
        style={style}
      >
        <div className="text-base leading-relaxed">
          {text}
        </div>

        <div className="flex justify-center pt-2">
          {children}
        </div>
      </div>
    </>
  );
}
